// extracted by mini-css-extract-plugin
export default {"container":"IndexParameter-module__container--bpHyl","label":"IndexParameter-module__label--Tgsaa"};